var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container",staticStyle:{"width":"100%"}},[_c('h1',[_vm._v("Austin Gentry")]),_c('h3',[_vm._v("Developer")])])
}]

export { render, staticRenderFns }